"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (count, params) {
    if (!count) {
        return params.none || '';
    }
    if (count === 1) {
        return params.one;
    }
    return params.some;
});
